import { fetchUser } from '@/routes/admin.tsx';
import { createFileRoute, redirect } from '@tanstack/react-router';
import ResetPassword from '../pages/auth/ResetPassword';

export const Route = createFileRoute('/reset-password')({
  beforeLoad: async () => {
    const user = await fetchUser();

    // De sessie komt uit /auth/confirm. Zonder sessie is de resetlink niet
    // (meer) geldig.
    if (!user) {
      throw redirect({ to: '/forgot-password' });
    }

    return {
      user,
    }
  },
  component: ResetPassword,
});
